"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ClayPortal", {
  enumerable: true,
  get: function get() {
    return _Portal.ClayPortal;
  }
});
Object.defineProperty(exports, "FocusScope", {
  enumerable: true,
  get: function get() {
    return _FocusScope.FocusScope;
  }
});
Object.defineProperty(exports, "getEllipsisItems", {
  enumerable: true,
  get: function get() {
    return _getEllipsisItems.getEllipsisItems;
  }
});
Object.defineProperty(exports, "LinkOrButton", {
  enumerable: true,
  get: function get() {
    return _LinkOrButton.LinkOrButton;
  }
});
Object.defineProperty(exports, "sub", {
  enumerable: true,
  get: function get() {
    return _sub.sub;
  }
});
Object.defineProperty(exports, "useDebounce", {
  enumerable: true,
  get: function get() {
    return _useDebounce.useDebounce;
  }
});
Object.defineProperty(exports, "useFocusManagement", {
  enumerable: true,
  get: function get() {
    return _useFocusManagement.useFocusManagement;
  }
});
Object.defineProperty(exports, "useTransitionHeight", {
  enumerable: true,
  get: function get() {
    return _useTransitionHeight.useTransitionHeight;
  }
});
exports.noop = void 0;

var _Portal = require("./Portal");

var _FocusScope = require("./FocusScope");

var _getEllipsisItems = require("./getEllipsisItems");

var _LinkOrButton = require("./LinkOrButton");

var _sub = require("./sub");

var _useDebounce = require("./useDebounce");

var _useFocusManagement = require("./useFocusManagement");

var _useTransitionHeight = require("./useTransitionHeight");

/**
 * © 2019 Liferay, Inc. <https://liferay.com>
 *
 * SPDX-License-Identifier: BSD-3-Clause
 */
var noop = function noop() {};

exports.noop = noop;